<template>
  <div class="modal-wrapper">
    <transition name="zoom-in">
      <div class="modal management-profile-modal" v-if="opened">
        <div class="management-profile-modal-content">
          <span class="kcm close" @click="close">J</span>
          <!-- IMAGE -->
          <div class="img-main desktop" :style="{ backgroundImage: `url(${content.img})` }"></div>
          <!-- TEXTS -->
          <div class="management-profile-modal-text">
            <div class="text-group-header-wrapper">
              <div class="text-group">
                <h3 class="text-accent">{{ content.position }}</h3>
                <h1 v-if="content.name">{{ content.name }}</h1>
                <div class="img-mobile mobile">
                  <img :src="content.img" :alt="content.name">
                </div>
                <template v-if="content.description">
                  <h2
                    class="desktop"
                    v-for="(d, i) in content.description"
                    :key="`description-item-${i}`"
                  >{{d}}</h2>
                </template>
                <ul class="desktop" v-if="content.list">
                  <li v-for="(l, i) in content.list" :key="`list-item-${i}`">{{l}}</li>
                </ul>
              </div>
            </div>
            <div class="text-group-lists-wrapper">
              <div v-if="content.description || content.list" class="text-group mobile">
                <template v-if="content.description">
                  <h2 v-for="(d, i) in content.description" :key="`description-item-${i}`">{{d}}</h2>
                </template>
                <ul v-if="content.list">
                  <li v-for="(l, i) in content.list" :key="`list-item-${i}`">{{l}}</li>
                </ul>
              </div>
              <div class="text-group" v-if="content.education">
                <h2>{{ $t('kcm-group-management-modal-1') }}</h2>
                <table class="years-table">
                  <tr v-for="(e, i) in content.education" :key="`education-item-${i}`">
                    <td>
                      <strong>{{ e.year }}</strong>
                    </td>
                    <td>-</td>
                    <td v-html="e.text"></td>
                  </tr>
                </table>
              </div>
              <div class="text-group" v-if="content.experience">
                <h2>{{ $t('kcm-group-management-modal-2') }}</h2>
                <table class="years-table">
                  <tr v-for="(e, i) in content.experience" :key="`experience-item-${i}`">
                    <td>
                      <strong>{{ e.year }}</strong>
                    </td>
                    <td>-</td>
                    <td v-html="e.text"></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['content'],
  data() {
    return {
      opened: false
    };
  },
  methods: {
    close() {
      this.$parent.$emit('close-modal');
    }
  },
  mounted() {
    setTimeout(() => {
      this.opened = true;
    }, 300);
  }
};
</script>


<style lang="scss" scoped>
.management-profile-modal {
  height: 100vh;
  max-height: 100vh;
  width: 100%;
  padding: 0;
  .management-profile-modal-content {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    height: 100%;
    overflow: auto;
    position: relative;
    width: 100%;
    z-index: 3;
    .close {
      cursor: pointer;
      font-size: 24px;
      position: absolute;
      top: calc(5% + 20px);
      padding: 10px;
      right: 5%;
      @include transition(all 0.3s);
      z-index: 3;
    }
    .close:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
    .img-main {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      display: block;
      height: 80%;
      width: calc(30% - 5vh);
      z-index: 1;
    }
    .management-profile-modal-text {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 0;
      position: relative;
      width: 70%;
      .text-group-header-wrapper {
        margin-top: 5vh;
        padding: 5vh 10% 30px 50px;
        position: relative;
        li {
          margin: 10px 0;
        }
        h2 {
          line-height: 24px;
        }
      }
      .years-table {
        font-size: 15px;
        tr {
          td {
            padding: 5px;
            vertical-align: top;
          }
          td:first-child {
            padding-left: 0;
            white-space: nowrap;
          }
          td:last-child {
            padding-right: 10px;
          }
        }
      }
      .text-group-header-wrapper::before {
        content: '';
        background-color: #b2c8d2;
        height: 100%;
        width: 100vw;
        right: 0;
        position: absolute;
        top: 0;
        z-index: -1;
      }
      .text-group-lists-wrapper {
        display: flex;
        overflow: auto;
        padding: 5vh 10% 30px 50px;
        z-index: 1;
        .text-group {
          width: 50%;
          h2 {
            margin-top: 0;
          }
        }
        .text-group:first-child {
          padding-right: 15px;
        }
      }
      .text-group {
        z-index: 1;
        h1 {
          margin: 30px 0;
        }
        h2 {
          font-size: 16px;
          margin: 10px 0;
          font-weight: 400;
        }
      }
    }
    .management-profile-modal-text::before {
      background-color: #e3e9ec;
      content: '';
      height: 100%;
      right: 0;
      opacity: 0.8;
      position: absolute;
      top: 0;
      width: 85vw;
    }
  }
}
.mobile {
  display: none;
}
@media screen and (max-width: 1440px) {
  .management-profile-modal {
    .management-profile-modal-content {
      .management-profile-modal-text {
        .text-group {
          h1 {
            margin: 20px 0;
          }
          h2 {
            font-size: 16px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .desktop {
    display: none !important;
  }
  .mobile {
    display: block;
  }
  .management-profile-modal {
    overflow: auto;
    .management-profile-modal-content {
      .img-mobile {
        align-items: center;
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: -23vw;
        @include transform(translateY(25vw));
        img {
          display: block;
          width: 50%;
        }
      }
      .management-profile-modal-text {
        width: 95vw;
        .text-group-header-wrapper {
          background-color: rgba(227, 233, 236, 0.8);
          padding: 30px 5vw 30px 20px;
          .text-group {
            z-index: 2;
          }
        }
        .text-group {
          position: relative;
          h1 {
            margin: 0 0 10px;
          }
          h3 {
            margin: 0;
          }
        }
        .years-table {
          font-size: 14px;
        }
        .text-group-lists-wrapper {
          background-color: rgba(227, 233, 236, 0.8);
          flex-direction: column;
          overflow: initial;
          padding-top: 25vw;
          padding-left: 20px;
          padding-bottom: 20px;
          .text-group {
            width: 100%;
            margin: 20px 0 0;
            h2 {
              font-size: 14px;
            }
          }
          .text-group:first-child {
            margin-top: 0;
            padding-right: 0;
          }
        }
      }
      .management-profile-modal-text::before {
        height: 5vh;
        width: 95vw;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .management-profile-modal {
    .management-profile-modal-content {
      .img-mobile {
        img {
          width: 80%;
        }
      }
      .management-profile-modal-text {
        .years-table {
          font-size: 13px;
        }
        .text-group {
          h1 {
            font-size: 18px;
          }
          h3 {
            width: 80%;
          }
        }

        .text-group-lists-wrapper {
          .text-group {
            h2 {
              font-size: 13px;
              line-height: 15px;
            }
          }
        }
      }
    }
  }
}
</style>

